// @flow
export { default } from './TrendingTemplate';



// WEBPACK FOOTER //
// ./src/components/trending/TrendingTemplate/index.js